export default __webpack_public_path__ + "static/media/3.5977ec1b.jpg";